import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterCondition,
  // CharacterFeatureSource,
  CharacterSheetInterface,
  Condition,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";
import DataUtilities from '@dndUtilities/data_utilities';

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import ConditionBox from "@dndComponents/other/ConditionBox";
import FilterBox from "@dndComponents/filtering/FilterBox";
import DandDAPI from "@dndUtilities/system_api";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  char: Character;
  char_interface: CharacterSheetInterface;
  disabled: boolean;
  // onChange: () => void;
  // onSourceChange: (source: CharacterFeatureSource, do_main: boolean) => void;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();
const data_util = DataUtilities.getInstance();

export default function CharacterConditionsButton({ 
  char,
  char_interface,
  disabled,
  // onChange,
  // onSourceChange // Not removing because I'm sure I'll add it in later
}: Props) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [conditions, setConditions] = useState<Condition[]>([]);
  // const [reloading, setReloading] = useState(false);
  // const [damage_multipliers, setDamageMultipliers] = useState<DamageMultiplierSimple[]>([]);
  const [rare, setRare] = useState(false);
  const [filter, setFilter] = useState<any>({});

  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  const renderConditionsInput = () => {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          Conditions
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <CenteredMenu
            options={["Common","Rare"]}
            selected={rare ? "Rare" : "Common"}
            onSelect={(changed: string) => { setRare(changed === "Rare"); }}
          />
        </Grid>
        { renderConditions() }
      </Grid>
    );
  }

  const renderConditions = () => {
    if (loading) {
      return (<LoadingBox />);
    } else {
      const enabled = !disabled;
      let use_conditions = conditions.filter(o => common_util.anyOverlaps(o.source_book_ids, char.character_options.source_books));
      use_conditions = use_conditions.filter(o => !o.exhaustion || o._id === char.character_options.exhaustion_id);
      const alternate_condition_originals = char_interface.alternate_condition_features.map(o => o.original_condition_id);
      const alternate_conditions = char_interface.alternate_condition_features.map(o => o.alternate_condition_id);
      const extra_ids = [
        ...char.classes.map(o => o.subclass_id),
        ...char.classes.map(o => o.source_id),
        ...char.character_options.show_extra_conditions
      ];
      
      // Iterate through conditions
      if (rare) {
        use_conditions = use_conditions.filter(o => 
          !alternate_conditions.includes(o._id) &&
          !o.common && !common_util.anyOverlaps(o.class_ids, extra_ids) && !common_util.anyOverlaps(o.subclass_ids, extra_ids));
      } else {
        use_conditions = use_conditions.filter(o => 
          !alternate_condition_originals.includes(o._id) &&
          (o.common || alternate_conditions.includes(o._id) || common_util.anyOverlaps(o.class_ids, extra_ids) || common_util.anyOverlaps(o.subclass_ids, extra_ids)));
      }
      use_conditions = api.filter("condition", use_conditions, filter) as Condition[];
      return (
        <>
          <Grid
            size={{
              xs: 12
            }}>
            <FilterBox
              data_type="condition"
              the_filter={filter}
              all_objects={conditions}
              onChange={setFilter}
            />
          </Grid>
          { use_conditions.map(cond => {
            const starred = char.favorite_conditions;
            const immune = char.condition_immunities;
            return (
              <Grid
                key={cond._id}
                size={{
                  xs: 12
                }}>
                <ConditionBox
                  char_int={char_interface}
                  onCharChange={() => {
                    char.changed();
                    char_util.repopulateCharFeatureBases(char);
                  }}
                  disabled={!enabled}
                  starred={starred.includes(cond._id)}
                  immune={immune.includes(cond._id)}
                  // active={char.condition_hash[cond._id]}
                  condition={cond}
                  onChange={ async (level: number) => {
                    let cc = char.conditions.find(o => o.source_id === cond._id);
                    if (level === 0) {
                      if (cc) {
                        char_util.removeCharFeatureBasesFor(char, cc);
                        char.conditions = char.conditions.filter(o => o.source_id !== cond._id);
                      }
                      // delete char.condition_hash[cond._id];
                    } else {
                      if (!cc) {
                        await api.loadObject(cond);
                        cc = new CharacterCondition();
                        cc.copy_source({ char, feature_source: cond });
                        char.conditions.push(cc);
                      }
                      cc.level = level;
                      // if (char.condition_hash[cond._id]) {
                      //   char.condition_hash[cond._id].level = level;
                      // } else {
                      //   char.condition_hash[cond._id] = { level, source_true_id: "" };
                      // }
                    }
                    // if (level === 0) {
                    //   delete char.condition_hash[cond._id];
                    // } else {
                    //   if (char.condition_hash[cond._id]) {
                    //     char.condition_hash[cond._id].level = level;
                    //   } else {
                    //     char.condition_hash[cond._id] = { level, source_true_id: "" };
                    //   }
                    // }
                    char.changed();
                    char_util.repopulateCharFeatureBases(char);
                  }}
                  onStar={() => {
                    if (char.favorite_conditions.includes(cond._id)) {
                      char.favorite_conditions = char.favorite_conditions.filter(o => o !== cond._id);
                    } else {
                      char.favorite_conditions.push(cond._id);
                    }
                    char.changed();
                    char_util.repopulateCharFeatureBases(char);
                  }}
                  onImmune={() => {
                    if (char.condition_immunities.includes(cond._id)) {
                      char.condition_immunities = char.condition_immunities.filter(o => o !== cond._id);
                    } else {
                      char.condition_immunities.push(cond._id);
                    }
                    char.changed();
                    char_util.repopulateCharFeatureBases(char);
                  }}
                />
              </Grid>
            );
          })}
        </>
      );
    }
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className={`centered header ${ disabled ? "" : "clickable"}`}
        onClick={() => {
          if (!disabled) {
            if (conditions.length === 0) {
              setLoading(true);
              data_util.getConditions().then(res => {
                setConditions(res);
                setLoading(false);
              });
            }
            setOpen(true);
          }
        }}
        size={{
          xs: 12
        }}>
        Conditions
      </Grid>
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
        }}>
        { open && renderConditionsInput() }
      </ModalOrDrawer>
    </Grid>
  );
}
